import React from 'react';
import './styles.css';
import LogoImage from './LogoImage';
import Navigation from './Navigation';

const SideBar = () => {

  return (
    <div className="side-nav-container">
      <div className="logo-wrapper">
        <LogoImage
          width={160}
          height={27}
        />
      </div>
      <div className="nav-wrapper">
        <Navigation />
      </div>
    </div>
  )
}

export default SideBar;